import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/cookies")({
  head: () => buildRouteHead("/cookies", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/cookie-statement", replace: true });
  },
});
